import { useState } from "react";
import { faqs } from "@/mocks/homeData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 font-label text-xs text-primary-600 tracking-widest">
              <i className="ri-question-line" />
              FAQ
            </span>
            <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950">
              常见问题
            </h2>
            <p className="mt-4 font-body text-sm md:text-base text-foreground-600 leading-relaxed">
              关于网站定位、内容来源与更新频率，这里整理了最常被问到的几个问题。
              如果还有疑问，欢迎通过页脚邮箱联系我们。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap cursor-pointer font-label text-sm text-primary-600 hover:text-primary-700"
            >
              <i className="ri-customer-service-2-line" />
              还有其他问题？联系我们
            </a>
          </div>

          <div className="lg:col-span-8">
            <dl className="rounded-lg border border-background-200 bg-background-50 divide-y divide-background-200 overflow-hidden">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q}>
                    <dt>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        className="w-full flex items-center justify-between gap-4 text-left px-5 py-5 cursor-pointer"
                        aria-expanded={isOpen}
                      >
                        <span className="font-heading font-bold text-base text-foreground-950">
                          {faq.q}
                        </span>
                        <span
                          className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md transition-colors ${
                            isOpen
                              ? "bg-primary-500 text-background-50"
                              : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                        </span>
                      </button>
                    </dt>
                    {isOpen && (
                      <dd className="px-5 pb-5 -mt-1">
                        <p className="font-body text-sm text-foreground-600 leading-relaxed">
                          {faq.a}
                        </p>
                      </dd>
                    )}
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}